import { useEffect, useRef } from 'react';

const useDebounce = (
    debouncedFunction: () => void,
    timeout = 500,
    dependencyArray: any[]
) => {
    const debounceRef = useRef<NodeJS.Timeout>();
    useEffect(() => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(debouncedFunction, timeout);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);

    return debounceRef;
};

// eslint-disable-next-line import/no-default-export
export default useDebounce;
